
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2a3cec57!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CrematoryEdit.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./CrematoryEdit.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-2a3cec57!../../node_modules/vue-loader/lib/selector?type=template&index=0!./CrematoryEdit.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/CrematoryEdit.vue
// module id = 398
// module chunks = 0